export interface SharePayload {
  title: string;
  text: string;
  url: string;
}

export type ShareResult = 'shared' | 'copied' | 'failed';

/**
 * Triggers native Web Share API if available, otherwise copies URL to clipboard.
 */
export async function shareProfile(payload: SharePayload): Promise<ShareResult> {
  if (navigator.share && typeof navigator.share === 'function') {
    try {
      await navigator.share({
        title: payload.title,
        text: payload.text,
        url: payload.url,
      });
      return 'shared';
    } catch (err: unknown) {
      if (err instanceof Error && err.name === 'AbortError') {
        return 'shared'; // User dismissed the share dialog
      }
      // Fallback to clipboard if share failed
    }
  }

  // Clipboard fallback
  try {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(payload.url);
      return 'copied';
    } else {
      // Legacy copy fallback
      const textArea = document.createElement('textarea');
      textArea.value = payload.url;
      textArea.style.position = 'fixed';
      textArea.style.opacity = '0';
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      return 'copied';
    }
  } catch (error) {
    console.error('Copy fallback failed:', error);
    return 'failed';
  }
}

